import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import Tooltip from "@amzn/meridian/tooltip";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const StageStatusViewV2 = (data) => {
    const {isMobile} = useDeviceLayout()
    const headerFont = isMobile ? "b100" : "h100"
    return (
        <Column spacing="small">
            <Tooltip position="right" title={data.stageStatus.tooltip ? data.stageStatus.tooltip : ""}> 
                <Text type={headerFont}>
                    <b><FormattedMessage id={data.stageStatus.title} defaultMessage={data.stageStatus.message}/></b>
                </Text>
            </Tooltip>
            <Text type="d50">{data.stageStatus.value}</Text>
            
        </Column>
    )
}

export default StageStatusViewV2


// WEBPACK FOOTER //
// ./src/components/stageStatus/StageStatusViewV2.js